import React, { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

const T1Technician: React.FC = () => {
  useSEO({
    title: 'TCP T1 BD T1 國內T1 適任技術人員註冊 - 焯峯工程 | 屋宇署認可工程監督',
    description: '焯峯工程提供專業TCP T1、BD T1及國內T1適任技術人員註冊服務，包括香港工程T1監督、國內工廠物料生產監督、玻璃熱浸Heat Soak Process監督和報告。確保工程項目符合屋宇署監督要求，同時提供村屋僭建物申報、TCP T3、BD T3、RSE T3服務。立即聯絡91898819獲取專業諮詢。',
    keywords: 'TCP T1,BD T1,國內T1,T1適任技術人員,T1註冊,屋宇署監督,工程監督服務,玻璃熱浸監督,Heat Soak Process,國內工廠監督,村屋僭建物申報,TCP T3,BD T3,RSE T3,焯峯工程',
    canonical: '/t1-technician',
    schema: {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "TCP T1 BD T1 國內T1 適任技術人員註冊服務",
      "description": "提供專業TCP T1、BD T1及國內T1適任技術人員註冊制度服務，確保工程項目符合屋宇署監督要求",
      "provider": {
        "@type": "Organization",
        "name": "焯峯工程有限公司",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
      },
      "areaServed": [
        {
          "@type": "Place",
          "name": "香港"
        },
        {
          "@type": "Place",
          "name": "中國內地"
        }
      ],
      "serviceType": "工程技術監督服務"
    }
  });

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const openImageModal = (imageSrc: string) => {
    setSelectedImage(imageSrc);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-red-50 to-red-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              T1適任技術人員註冊服務
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              提供專業T1適任技術人員註冊制度服務，確保工程項目符合屋宇署監督要求
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/ce730601509fc31659d2544f45082e09.jpeg"
                alt="T1適任技術人員服務"
                className="w-full h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">T1技術人員服務範圍</h2>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-shield-check-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">香港工程T1監督 (以日計算和以工程計算)</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-shield-check-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">國內工廠物料生產superstructure的T1監督</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-shield-check-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">玻璃熱浸Heat Soak Process T1監督和報告</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Report Samples Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">報告樣本</h2>
            <p className="text-lg text-gray-600">專業T1監督報告範例</p>
          </div>
          
          {/* T1 Superstructure 國內加工廠報告樣本 */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">T1 Superstructure 國內加工廠報告樣本</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/c0848df9f7b28ebbe5a8289c111f4317.png')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/c0848df9f7b28ebbe5a8289c111f4317.png"
                  alt="工廠生產監督報告"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>

              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/3170c131cf9dff35fb77e233172320d4.png')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/3170c131cf9dff35fb77e233172320d4.png"
                  alt="品質檢驗報告"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>

              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/26d5a875cb680d55f580fb5939b45f47.png')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/26d5a875cb680d55f580fb5939b45f47.png"
                  alt="安全合規報告"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>

              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/63971913cfd121d98f2b4de70c7364f3.png')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/63971913cfd121d98f2b4de70c7364f3.png"
                  alt="技術評估報告"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>
            </div>
          </div>

          {/* T1 Heat Soak Process 玻璃熱浸報告樣本 */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">T1 Heat Soak Process 玻璃熱浸報告樣本</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/1396997827eee5e4df93bb5bf8d367f3.jpeg')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/1396997827eee5e4df93bb5bf8d367f3.jpeg"
                  alt="熱浸處理監督報告"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>

              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/5c027bbb9daa8230fc236a7819697dab.jpeg')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/5c027bbb9daa8230fc236a7819697dab.jpeg"
                  alt="溫度監控記錄"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>

              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/47f5578437709c30b34047ca8762c62f.jpeg')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/47f5578437709c30b34047ca8762c62f.jpeg"
                  alt="熱浸監督證書"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>

              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow"
                onClick={() => openImageModal('https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/423bdfa2071173e58c166ab93b6fd182.jpeg')}
              >
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/423bdfa2071173e58c166ab93b6fd182.jpeg"
                  alt="品質保證報告"
                  className="w-full h-64 object-contain bg-gray-50"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeImageModal}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300 transition-colors z-10"
            >
              <i className="ri-close-line"></i>
            </button>
            <img 
              src={selectedImage}
              alt="報告樣本放大圖"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-16 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">需要T1適任技術人員服務？</h2>
          <p className="text-xl text-red-100 mb-8">專業團隊為您提供全面的技術監督服務</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即諮詢
            </button>
            <a 
              href="https://wa.me/85291898819"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp 諮詢
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default T1Technician;
